<!--
<div>
  <div class="example-container">
    <form class="form">
      <div class="row">
        <testo type='testo' class="col-6" [(inputModel)]="nomeCognome" [errore]="errori.nomeCognome" placeholder="Nome e Cognome" noDiv=true></testo>
        <testo type='email' class="col-6" [(inputModel)]="email" [errore]="errori.email" placeholder="E-mail" noDiv=true></testo>
  
      </div>
      
      <div class="row">
        <file class="nascondiX" #file [(inputModel)]="allegato" name="allegato" label="Allega File" [errore]="errori.file" accept="application/pdf,application/pkcs7-mime,application/x-pkcs7-mime">
        </file>
      </div>
      <div class="row">
        <div class="offset-4 col-4"><input type="checkbox" [checked]="!privacy" (change)="checkBox()"/> Ho preso visione dell'<a style="padding-left: 10px; padding-right:10px;" href="www.google.it">informativa sulla privacy.</a><button [disabled]="privacy" class="btn btn-save btn-secondary btn-sal" (click)="invia()">Invia</button>
        </div>
      </div>
    </form>
  </div>
</div>
-->

<div class="container mt-3 mb-3">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card card-outline-secondary">
        <div class="card-body">
          <form>
            <h2 class="row justify-content-center mb-5">Condividi con noi i tuoi progetti!</h2>
            <div class="row">
              <div class="mb-3">
                <label for="nomeCognome" class="form-label">Nome e Cognome</label>
                <input [(ngModel)]="nomeCognome" name="nomeCognome"  type="text" class="form-control" id="nomeCognome"/>
                <div style="color: red;" class="form-text align-right">
                  {{errori.nomeCognome}}
                 </div>
              </div>
              
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input [(ngModel)]="email" name="email" type="email" class="form-control" id="email"/>
                <div style="color: red;" class="form-text align-right">
                  {{errori.email}}
                 </div>
              </div>
              
              <div class="row input-group mb-3 mt-3">
                <input type="file" id="fileProgetto" class="form-control" placeholder="Scegli un file..." aria-label="Recipient's username" aria-describedby="basic-addon2" (click)="file1.value = null" value="" (change)="handleFileInput($event.target.files)" hidden #file1 accept="application/pdf">
                <label *ngIf="allegato == null" class="col-9" style="color: darkgray;font-style: italic; padding: 0.5rem 0.8rem;">Scegli un file..</label>
                <label *ngIf="allegato" class="col-9" style="padding: 0.5rem 0.8rem;">{{allegato.name}}</label>
              
                
                <div class="col-3 input-group-append" style="text-align: right;">
                  <button *ngIf="allegato == null" style="margin: 0px; min-width: unset;" class="btn btn-secondary" type="button" (click)="file1.click()">Carica</button>
                  <button *ngIf="allegato" style="margin: 0px; min-width: unset;" class="btn btn-danger" type="button" (click)="eliminaFile()">Elimina</button>
                </div>
                <div class="form-text align-right">
                 Sono accettati solo file in formato .pdf di dimensione non superiore a 20 MB.
                </div>
                <div style="color: red;" class="form-text align-right">
                  {{errori.file}}
                 </div>
              </div>
              
              <div class="mb-4 ">
                <div class="form-check justify-content-center">
                  <input type="checkbox" [checked]="!privacy" (change)="checkBox()" class="ml-10 form-check-input " id="privacyCheck">

                  <label class="form-check-label" for="exampleCheck1">
                    Ho preso visione e accetto le condizioni esposte nella pagina dedicata alla <a target="_blank" href="https://oil.coll.fondirigenti.it/privacyregolamento">privacy e al regolamento OIL</a>.</label>
                </div>
              </div>
  
              <div class="text-center">      
                <button [disabled]="privacy" type="submit" class="btn btn-primary" (click)="invia()">Condividi progetto</button>
              </div>
            </div>
          </form>
        
      </div>
    </div><!-- col-md-6 -->
  </div>
</div>
</div>